import { render, staticRenderFns } from "./TransportCostsManyForm.vue?vue&type=template&id=4235393d&"
import script from "./TransportCostsManyForm.vue?vue&type=script&lang=ts&"
export * from "./TransportCostsManyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports